import { useLocation } from "react-router-dom";
import { doLogout, isScmAuthenticated } from "../common/utility";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import Forbidden from "../pages/Forbidden";
import { Paths } from "../Routes/path";
import ScmHeader from "../components/molecules/ScmHeader";

const Scm = ({ children, forbidden }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    !isScmAuthenticated() && doLogout();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const page = Object.values(Paths).find((item) => item.path === pathname);
    page && (document.title = page.title);
  }, [pathname]);

  return (
    <>
      <ScmHeader />
      {!forbidden && children}
      {forbidden && <Forbidden />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    forbidden: state.forbidden,
  };
};

export default connect(mapStateToProps, null)(Scm);
